module.exports = __webpack_public_path__ + "img/arrearage_reminder_un.56df7f03.png";